<template>
  <div class="coupon_box">
    <div class="boxtit">
      特選屋苑優惠券使用情況
    </div>
    <div class="box_sel">
      <el-row>
        <el-col :span="24">
          <el-input
            v-model.trim="couponKeyword"
            class="w200 mr4"
            placeholder="請輸入特選屋苑優惠券"
            suffix-icon="el-icon-search"
            @keyup.enter.native="searchCoupon"
          />
          <el-button
            type="danger"
            class="selButton"
            @click="searchCoupon"
          >
            查詢特選屋苑優惠券
          </el-button>
        </el-col>
        <el-col v-show="showStatus">
          <div class="couname">
            特選優惠券活動名稱：{{ batchName }}
          </div>
          <el-select
            v-model="zoneCode"
            class="w200 mr4 seled"
            placeholder="地區"
            no-data-text="暫無數據"
          > 
            <el-option
              label="全部"
              :value="0"
              @click.native="resetPhamore('zonecode')"
            />
            <el-option
              v-for="item in gscope"
              :key="item.gscopeCode"
              :value="item.gscopeCode"
              :label="item.gscopeNameWithCulture"
              @click.native="resetPhamore('zonecode')"
            />
          </el-select> 
          <el-select
            v-model="estateName"
            class="w200 mr4 seled"
            filterable
            remote
            :remote-method="remoteEstate"
            popper-class="custom-select-dropdown"
            placeholder="搜尋：屋苑或大廈名稱"
            clearable
            no-data-text="暫無數據"
            @focus="clearIndex"
            @blur="hasMoreData=true"
            @change="handleEstateChange"
            @clear="cancelSearch"
          >
            <el-option
              v-for="(item, index) in estate"
              :key="index"
              :label="item.value"
              :value="item.value"
            />
          </el-select>
          <el-select
            v-model="phaseWithCulture"
            class="w200 mr4 seled"
            placeholder="請選擇期數"
            clearable
            no-data-text="暫無數據"
            @clear="setPhaBuild('clearPhase')"
          >
            <el-option
              v-for="(item, index) in estAdress.phaseEstates"
              :key="index"
              :label="item.phaseWithCulture"
              :value="item.phaseWithCulture"
              @click.native="setPhaBuild('phase', item)"
            />
          </el-select>
          <el-select
            v-model="buildingNameWithCulture"
            class="w200 seled"
            placeholder="請選擇座數"
            clearable
            no-data-text="暫無數據"
            @clear="setPhaBuild('clearBuild')"
          >
            <el-option
              v-for="(item, index) in estAdress.buildings"
              :key="index"
              :label="item.buildingNameWithCulture"
              :value="item.buildingNameWithCulture"
              @click.native="setPhaBuild('build', item)"
            />
          </el-select>
        </el-col>
      </el-row>
    </div>
    <div class="box_con">
      <el-table
        v-loading="listLoading"
        :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }"
        :data="tableData"
        style="width: 100%"
        fit
      >
        <el-table-column
          label="適用屋苑"
          prop="estateName"
        />
        <el-table-column label="適用期數">
          <template slot-scope="scope">
            <span>{{ scope.row.phase ? scope.row.phase : '不限' }}</span> 
          </template>
        </el-table-column>
        <el-table-column label="適用座數">
          <template slot-scope="scope">
            <span>{{ scope.row.buildingName ? scope.row.buildingName : '不限' }}</span> 
          </template>
        </el-table-column>
        <el-table-column label="可放盤數量">
          <template slot-scope="scope">
            <span>{{ scope.row.remainderNumBuilding && scope.row.buildingID ? scope.row.remainderNumBuilding : scope.row.remainderNumEstate }}</span> 
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span
              :class="[
                (scope.row.remainderNumBuilding && scope.row.buildingID
                  ? scope.row.remainderNumBuilding
                  : scope.row.remainderNumEstate) > 0
                  ? 'go_add'
                  : 'dis_add'
              ]"
              @click="goAdd(scope.row)"
            >
              刊登樓盤
            </span>
            <!-- <span :class="[scope.row.remainderNumBuilding > 0 ? 'go_add' : 'dis_add' ]" @click="goAdd(scope.row)">刊登樓盤</span>  -->
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-right"
        :total="total"
        :page.sync="pageIndex"
        :limit.sync="pageCount"
        @pagination="loadCouponList"
      />
    </div>
    <el-dialog
      title="刊登樓盤"
      width="480px"
      :visible.sync="isEnterPost"
    >
      <div class="post-enters">
        <el-row>
          <el-col :span="12">
            <el-button
              type="primary"
              class="btn_txt"
              @click="goAddType(1)"
            >
              刊登售盤
            </el-button>
          </el-col>
          <el-col :span="12">
            <el-button
              type="primary"
              class="btn_txt"
              @click="goAddType(2)"
            >
              刊登租盤
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data() {
        return {
            isEnterPost:false,
            couponKeyword:'',
            estateName:'',
            gscope:[],
            zoneCode:'',//地区code
            estateID:'',
            parentEstateID:'',//存在期数时，此字段为屋苑id
            estAdress:[],
            phaseWithCulture:'',
            buildingNameWithCulture:'',
            buildingsList:[],
            tableData:[],
            batchName:'',
            pageIndex: 1,
            pageCount: 50,
            total: 0,
            listLoading:false,
            showStatus:false,
            userInfo: [],
            rentalType:'',
            addData:{},
            phaseItem:{},
            isQueryCouponRange:true,
            cancelTokenSource: null,
            zoneID:'',
            estate:[],
            estateIndex:1,
            estateCount:50,
            estatelistLoading:true,
            hasMoreData: true,
            estateKeyWord:''
        }
    },
    created(){
        this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
            if (res.data.code === 0 && res.data.result) {
                this.isQueryCouponRange = res.data.result.isQueryCouponRange;
            }
        })
        this.axios.get(this.pub.getApi().GetCompanyUserInfo).then(res => {
            if (res.data.code === 0 && res.data.result) {
                this.userInfo = res.data.result;
            }
        });
        if(!this.isQueryCouponRange || this.userInfo.roleID == 4){
            this.$router.push('/')
        }
        this.getGscope()
        this.tableData=[]
    },
    mounted() {
    this.$nextTick(() => {
      const dropdownWrap = document.querySelector('.custom-select-dropdown .el-select-dropdown__wrap');
      if (dropdownWrap) {
        dropdownWrap.addEventListener('scroll', this.handleScroll);
      }
    });
  },
  beforeDestroy() {
    const dropdownWrap = document.querySelector('.custom-select-dropdown .el-select-dropdown__wrap');
    if (dropdownWrap) {
      dropdownWrap.removeEventListener('scroll', this.handleScroll);
    }
  },
    methods:{
        goAddType(type){
            this.rentalType = type
            this.goAdd(this.addData)
            this.addData = {}
        },
        goAdd(item){
            if ((item.buildingID && item.remainderNumBuilding < 1) || 
                (!item.buildingID && item.remainderNumEstate < 1)) {
               return;
            }
            if(this.rentalType == ''){
                if(item.rentalType == '1' || item.rentalType == '2' ){
                    this.rentalType = item.rentalType
                }else{
                    this.addData = item
                    this.isEnterPost = true;
                    return 
                }
            }
            let propertyData = {
                origin:'zycoupon',
                estateID: item.estateID,
                buildingID: item.buildingID,
                parentEstateID:item.parentEstateID?item.parentEstateID:'',
                estateNameWithCulture:item.estateName,
                topType:item.topType,
                zoneID:this.zoneID,
                couponKeyword:this.couponKeyword
            }
            this.$router.push({
                name: this.pub.routeNameLists.Post,
                params: propertyData,
                query: {
                    rentalType: this.rentalType,
                }
            });

        },
        cancelSearch() {
            this.estateName = '';
            this.hasMoreData = true
            this.estateKeyWord = ''
            this.estateID = ''
            this.estAdress.phaseEstates = []
            this.estAdress.buildings = []
            this.buildingID = ''
            this.pageIndex = 1;
            this.phaseWithCulture =''
            this.buildingNameWithCulture = ''
            this.loadCouponList()
        },
        // 地区切换 清空期座
        resetPhamore(type){
            this.estateName = ''
            this.phaseWithCulture =''
            this.buildingNameWithCulture = ''
            this.estateID = ''
            this.buildingID = ''
            this.estAdress.phaseEstates = []
            this.estAdress.buildings = []
            this.pageIndex = 1;
            if(type != 'searchCoupon'){
                this.loadCouponList()
            }else{
                //搜索优惠券时 清空地区
                this.zoneCode = ''
            }
        },
        loadCouponList() {
            /**取消之前的请求
             * eg:共27项，先选10项/页 然后翻到第二页 然后换到50项/页会出现页面空白问题（
             * 因为触发了两次事件，一次（50，2）返回空值，一次（50，1）返回有值，页面会采用第一次调用故空值）
             * */ 
            if (this.cancelTokenSource) {
                this.cancelTokenSource.cancel('Request canceled due to new request.');
            }

            // 创建新的 cancel token source
            this.cancelTokenSource = this.axios.CancelToken.source();

            this.listLoading = true;
            this.axios.post(this.pub.getApi().SearchCouponBatchEstate, {
                pageIndex: this.pageIndex,
                pageCount: this.pageCount,
                batchName : this.batchName,
                zoneCode: this.zoneCode == 0 ? '' : this.zoneCode,
                couponKeyword: this.couponKeyword, // 卡密/活动批次名称
                estateID: this.estateID, // 楼盘id
                buildingID: this.buildingID, // 座数id
            }, {
                cancelToken: this.cancelTokenSource.token
            }).then(res => {
                if (res.data.code == 0) {
                    this.tableData = res.data.result.data;
                    this.total = res.data.result.count;
                    this.listLoading = false;
                }
            }).catch(error => {
                if (this.axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                } else {
                    // 处理其他错误
                    console.error('Error occurred:', error);
                }
                this.listLoading = false;
            });
        },
        searchCoupon(){
            this.pageIndex = 1;
            this.pageCount = 50;
            let data = 
                {
                    "isOnlyVerifyBasic":true,
                    "couponKeyword": this.couponKeyword, 
                }
            this.axios.post(this.pub.getApi().VerifyCouponKeyword,data).then(res=>{
                if(res.data.code == 0){
                    this.showStatus = res.data.result.status
                    this.resetPhamore('searchCoupon')
                    this.tableData=[]
                    if(!this.showStatus){
                        this.total=0
                        this.$message({
                            message: res.data.result.message,
                            type: 'error',
                            showClose: true
                        });
                    }else{
                        this.zoneID = res.data.result.zoneID
                        this.batchName = res.data.result.batchName
                        this.searchEstate()
                        this.loadCouponList()
                    }
                }
            })
        },
        getGscope() {
            this.axios.get(this.pub.getApi().GetGscope).then((res)=>{
                res.data.result.forEach(item => {
                    if(item.gscopeCode != "HK10"){
                        item.children.forEach(i => {
                            this.gscope.push(i);
                        });
                    }
                });
            })
        },
        handleScroll(event){
            const { scrollTop, clientHeight, scrollHeight } = event.target;
            if (scrollTop + clientHeight >= scrollHeight - 10 && this.hasMoreData) { // 10 是一个缓冲区，可以根据需要调整
                this.estateIndex++;
                this.searchEstate();
            }
        },
        handleEstateChange(value) {
            // 通过 value 找到对应的 item
            const selectedEstate = this.estate.find(item => item.value === value);
            if (selectedEstate) {
                this.setEstate(selectedEstate)
            }
        },
        clearIndex(){
            if(this.estateName){
                this.estateKeyWord = this.estateName
            }else{
                this.estateKeyWord = ''
            }
            this.estateIndex = 1
            this.estate=[]
            this.searchEstate()
        },
        async remoteEstate(query){
            // if(!query)return
            this.estateKeyWord = query
            this.estateIndex = 1
            this.estateCount = 50
            this.estate=[]
            await this.searchEstate()
        },
        // 搜索屋苑列表
        async searchEstate(query){
            return new Promise((resolve, reject) => {
            let zoneCode = []
            if(this.zoneCode){
                zoneCode.push(this.zoneCode)
            }else{
                zoneCode = []
            }
            this.estatelistLoading = true
            this.axios
                .post(this.pub.getApi().SearchCouponEstate, {
                    keywords: this.estateKeyWord,
                    zoneCode:zoneCode,
                    batchName : this.batchName,
                    ZoneID:this.zoneID,
                    pageIndex: this.estateIndex,
                    pageCount: this.estateCount,
                    parentEstateId: 0,
                })
                .then(res => {
                    if(res.data.code === 0 && res.data.result){
                        const newData = res.data.result.data;
                        newData.sort((a, b) => {
                        if (!a.phaseWithCulture && b.phaseWithCulture) {
                            return -1;
                        } else if (a.phaseWithCulture && !b.phaseWithCulture) {
                            return 1;
                        }
                        return 0;
                        }).map((item,index) => {
                            const { gscopeNameWithCulture, estateNameWithCulture, phaseWithCulture } = item;
                            item.value = gscopeNameWithCulture + ' ' + estateNameWithCulture + ' ' + (phaseWithCulture ? phaseWithCulture : '');
                            return item;
                        });
                        // this.estate = newData; 
                        this.estate = this.estate.concat(newData);
                        if (newData.length < this.estateCount) {
                            this.hasMoreData = false; // 如果返回的数据少于请求的数量，表示没有更多数据
                        }
                        // this.total = res.data.result.count;
                        this.estatelistLoading = false;
                    }
                })
                .catch((error) => {
                    console.error('Error occurred:', error);
                    this.estatelistLoading = false;
                });
                resolve()

            })

        },
        async setEstate(item) {
            // 选中了暂无数据时 将屋苑名清空
            if(!item.estateNameWithCulture){
                this.estateName = ''
                return
            }
            this.estateName = item.estateNameWithCulture
            await this.axios
                .get(this.pub.getApi().GetEstate, {
                params: { estateId: item.estateID }
                })
                .then(res => {
                if (res.data.code === 0 && res.data.result) {
                        this.EstateInfo = res.data.result;
                        this.estateID = this.EstateInfo.estateID;
                        this.estateIndex =1;
                        // this.estateKeyWord = ''
                        // 当选中屋苑+期数时,期数自动补充
                        if(item.parentEstateID){
                            this.phaseWithCulture = item.phaseWithCulture
                        }
                        // parentEstateID(父屋苑ID)
                        let id = item.parentEstateID ? item.parentEstateID : item.estateID
                        this.parentEstateID = item.parentEstateID
                        this.getPhaBuild(id, item.estateID)
                        this.estateName = this.EstateInfo.estateNameWithCulture;

                        // 用户选中某一项后 输入框中显示选中值 下拉框内容需要根据选中值重新搜索
                        this.estateKeyWord = this.estateName
                        this.estate = []
                        this.searchEstate()
                        this.pageIndex = 1
                        this.loadCouponList()
                    }
                });
            
        },
        getPhaBuild(parentid,estateID) {
            return new Promise((suc, err) => {
                this.axios
                .get(this.pub.getApi().GetPhasesAndBuildingForPublish, {
                    params: { estateId: parentid }
                }).then(res => {
                    this.estAdress.phaseEstates = res.data.result.estatePhases
                    this.buildingsList = res.data.result.buildingResponses
                    this.estAdress.buildings = res.data.result.buildingResponses
                    if (this.phaseWithCulture) {
                        this.estAdress.buildings = this.buildingsList.filter(it => {
                            return it.estateID == estateID
                        })
                    }
                    suc()
                })
            }
            )
        },
        // 期座切换 处理内容
        setPhaBuild(type, item) {
            this.pageIndex = 1;
            if (type == "build") {
                this.buildingNameWithCulture = item.buildingName
                this.buildingID = item.buildingID
            }else if(type == 'clearBuild'){
                this.buildingNameWithCulture = ''
                this.buildingID = ''
            } else if (type == 'phase' || type == 'clearPhase') {
                // 储存清空pahse值
                if(type == 'phase'){
                    this.phaseItem = item
                }
                this.estateID = type == 'phase' ? this.phaseItem.estateID :this.phaseItem.parentEstateID
                // 根据期数筛选座数
                this.estAdress.buildings = this.buildingsList.filter(it => {
                    return it.estateID == this.phaseItem.estateID
                })
                if(type == 'clearPhase'){
                    // 更新期数之后 座数置空
                    this.buildingID = ''
                    this.buildingNameWithCulture = ''
                    this.estAdress.buildings = this.buildingsList
                    if(this.parentEstateID){
                        this.estateID = this.parentEstateID
                    }
                }
                
            }
            this.loadCouponList()     
        },
    }
}
</script>

<style scoped lang="less">
.coupon_box{
    /deep/.el-dialog {
        border-radius: 10px;
    }
    .post-enters {
        padding: 25px 30px 40px;
        text-align: center;
        .btn_txt {
            font-size: 30px;
            padding: 16px 18px;

        }
        .el-button {
            width: 85%;
            height: 100%;
        }
    }
    text-align: left;
    .boxtit{
        text-align: left;
        font-size: 24px;
        color: #171725;
        margin-bottom: 20px;
    }
    .box_sel{
        margin-bottom: 20px;
        .seled {
            ::placeholder {
                color: #000000;
            }
        }
        /deep/.el-input__inner {
            border-radius: 10px !important;
        }
        .couname{
            margin: 15px 0;
        }
        .selButton{
            border-radius: 12px;
            background-color: #E50113;
        }
        .w200{
            width: 200px;
        }
        .w120{
            width: 120px;
        }
        .mr4{
            margin-right: 15px;
        }
    }
    .box_con{
        background-color: #ffffff;
        padding: 20px 20px 0 20px;
        border-radius: 10px;
        height: calc(100% - 80px);
        /deep/table {
            color: #222;
            font-size: 14px;
            tr th .cell {
                font-size: 12px;
                color: #44444f;
            }
        }
        /deep/.el-table__header-wrapper {
            border-radius: 10px;
            height: 38px;
        }
        .bottom-right {
            text-align: right;
        }
        .go_add{
            color: #0062FF;
            cursor: pointer;
        }
        .dis_add{
            color:#696974 ;
            cursor: not-allowed;
        }
    }
}
</style>